import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Grid as MuiGrid } from '@mui/material';
import { motion } from 'framer-motion';
import { Verified as VerifiedIcon } from '@mui/icons-material';

const MotionCard = motion.create(Card);
const Grid = MuiGrid as any;

interface Certification {
  title: string;
  issuer: string;
  code: string;
  year: string;
  certNumber?: string;
}

const certifications: Certification[] = [
  {
    title: 'AWS Certified Machine Learning Engineer - Associate',
    issuer: 'Amazon Web Services (AWS)',
    code: 'MLA-C01',
    year: 'Dec 2025 · Expires Dec 2028',
    certNumber: 'AWS04523767',
  },
  {
    title: 'AWS Certified AI Practitioner',
    issuer: 'Amazon Web Services (AWS)',
    code: 'AIF-C01',
    year: 'Issued: Oct 2024',
    certNumber: 'AWS04523767',
  },
  {
    title: 'AWS Certified Solutions Architect – Associate',
    issuer: 'Amazon Web Services (AWS)',
    code: 'SAA-C03',
    year: 'Issued: Sep 2024',
    certNumber: 'AWS04523767',
  },
  {
    title: 'AWS Certified Cloud Practitioner',
    issuer: 'Amazon Web Services (AWS)',
    code: 'CLF-C02',
    year: 'Issued: Aug 2024',
    certNumber: 'AWS04523767',
  },
//   {
//     title: 'Machine Learning Specialization (3 Courses)',
//     issuer: 'Stanford University',
//     code: '',
//     year: 'Issued: Oct 2023',
//   },
//   {
//     title: 'Data Science and Data Engineering Bootcamp',
//     issuer: 'Data Science Dojo',
//     code: '',
//     year: 'Issued: Nov 2017',
//     certNumber: '899f61de',
//   },
  {
    title: 'Penetration Tester / Ethical Hacker',
    issuer: 'GIAC Certifications',
    code: 'GPEN',
    year: 'Mar 2014',
    certNumber: '139057',
  },
  {
    title: 'Certified Information Systems Security Professional',
    issuer: 'International Information System Security Certification Consortium',
    code: 'CISSP',
    year: '2012',
    certNumber: '412284',
  },
  {
    title: 'Microsoft Certified Database Administrator',
    issuer: 'Microsoft',
    code: 'MCDBA',
    year: '2001',
    certNumber: '1463461',
  },
  {
    title: 'Microsoft Certified System Engineer',
    issuer: 'Microsoft',
    code: 'MCSE',
    year: '1999',
    certNumber: '1463461',
  },

];

const Certifications = () => {
  return (
    <Box sx={{ py: { xs: 2, md: 4 } }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Certifications
      </Typography>
      <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
        <Grid container spacing={3}>
          {certifications.map((cert, index) => (
            <Grid key={cert.title} sx={{ gridColumn: { xs: 'span 12', md: 'span 4' } }}>
              <MotionCard
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  backgroundColor: 'background.paper',
                  borderRadius: 2,
                  p: 3,
                  justifyContent: 'flex-start',
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 0, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', height: '100%' }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <VerifiedIcon color="primary" sx={{ mr: 1 }} />
                    <Typography variant="h6" component="h2" sx={{ fontSize: '1.1rem', fontWeight: 600 }}>
                      {cert.title}
                    </Typography>
                  </Box>
                  <Typography variant="subtitle2" color="text.secondary" sx={{ fontStyle: 'italic', mb: 1, ml: 4 }}>
                    {cert.code || ''}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1, ml: 4 }}>
                    {cert.issuer || ''}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1, ml: 4 }}>
                    Issued: {cert.year ? cert.year.replace('Issued: ', '') : ''}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ ml: 4 }}>
                    ID: {cert.certNumber || ''}
                  </Typography>
                </CardContent>
              </MotionCard>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default Certifications; 